import { getTerraConfigValue } from './config-provider';

function resolveGatewayRootBaseUrl(): string {
  const configured = getTerraConfigValue('NEXT_PUBLIC_API_GATEWAY_ADDRESS');
  if (!configured) {
    return '';
  }
  return configured.trim().replace(/\/$/, '');
}

export function resolveGatewayServiceBaseUrl({
  serviceName,
}: {
  serviceName?: string;
}): string {
  if (!serviceName) {
    return resolveGatewayRootBaseUrl();
  }
  return `${resolveGatewayRootBaseUrl()}/${serviceName}`;
}
